import React, { Component, PropTypes } from 'react';
import { push as routerPush } from 'react-router-redux';
import { connect } from 'react-redux';
import HistoryAction from '../contracting/generic-components/history-action';

class contentMessage extends Component {
  render() {
    return <HistoryAction {...this.props} />;
  }
}
contentMessage.defaultProps = {
  attachments: [],
};
contentMessage.propTypes = {
  myCompanyId: PropTypes.string,
  participant: PropTypes.object,
  routerPush: PropTypes.func,
};

const select = (state) => ({
  myCompanyId: state.user.getIn(['company', 'companyId']),
});

export default connect(select, {
  routerPush,
})(contentMessage);



// WEBPACK FOOTER //
// ./src/app/components/workspace/content-message.jsx